import i18n from '../i18n';

/**
 * The two send failures that come from a Settings → Requests / Editor choice,
 * worded in the user's language.
 *
 * Rust returns stable tokens for them (`request_preferences.rs`) rather than
 * English prose, because only the webview knows the language and the names
 * the settings have in it:
 *   * `response_too_large:<limit in bytes>` — Max response size;
 *   * `http2_not_negotiated: <cause>`       — HTTP version = HTTP/2 only; the
 *     raw cause is ALWAYS appended, so a wrong attribution can still be seen.
 *
 * Returns null for anything else, so the caller's generic handling applies.
 */
export function explainRequestSettingsError(raw) {
  const msg = String(raw ?? '').trim();
  const tooLarge = /^response_too_large:(\d+)/.exec(msg);
  if (tooLarge) {
    const mb = Number(tooLarge[1]) / (1024 * 1024);
    return i18n.t('settings.responseTooLarge', {
      mb: Number.isInteger(mb) ? String(mb) : mb.toFixed(1),
    });
  }
  const h2 = /^http2_not_negotiated:\s*(.*)$/s.exec(msg);
  if (h2) {
    const cause = h2[1].replace(/^error sending request for url \([^)]*\):\s*/i, '').trim();
    return i18n.t('settings.http2NotNegotiated', { cause: cause || '—' });
  }
  return null;
}
